import { sessionEvents } from '../features/auth/sessionEvents';
import { responseSessionFailure } from '../features/auth/sessionPolicy';
/** Observe failures without altering responses, credentials, SDK rotation or retrying requests. */
export function sessionAwareFetch(baseUrl: string, fetcher: typeof fetch = (...args) => fetch(...args)): typeof fetch {
  const origin = new URL(baseUrl).origin;
  return async (input, init) => {
    const target = new URL(typeof input === 'string' ? input : input instanceof URL ? input.href : input.url, baseUrl);
    const refresh = target.origin === origin && target.pathname === '/auth/v1/token' && target.searchParams.get('grant_type') === 'refresh_token';
    const rest = target.origin === origin && target.pathname.startsWith('/rest/v1/');
    const revision = sessionEvents.revision();
    let response: Response;
    try {
      response = await fetcher(input, init);
    } catch (error) {
      if (refresh && revision === sessionEvents.revision()) sessionEvents.publish({
        source: 'refresh',
        kind: 'transient',
        code: 'network',
        status: 0
      });
      throw error;
    }
    if (refresh && !response.ok || rest && (response.status === 401 || response.status >= 500)) {
      try {
        const failure = responseSessionFailure(refresh ? 'refresh' : 'rest', response.status, await response.clone().json());
        if (failure && revision === sessionEvents.revision()) sessionEvents.publish(failure);
      } catch {/* Preserve the original response when error JSON is unavailable. */}
    }
    return response;
  };
}
